"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const variables_scss_1 = __importDefault(require("../../../styles/variables.scss"));
const { primary, seaPrimaryWithAlpha } = variables_scss_1.default;
const Styles = {
    disabled: (disabled = false) => (0, core_1.css) `
    ${disabled && `
        background-color: #cecece;
        border: 2px solid #cecece;
        cursor: default; 
    `}`,
    statefulAnchor: (selected) => (0, core_1.css) `
    ${selected && `
        background-color: ${seaPrimaryWithAlpha};
        span {
          color: ${primary};
        }
        svg {
          filter: invert(53%) sepia(81%) saturate(777%) hue-rotate(159deg) brightness(98%) contrast(80%);
        }
    `}
  `,
};
exports.default = Styles;
